import { render, staticRenderFns } from "./ListReferralNodes.vue?vue&type=template&id=4a55f842&"
import script from "./ListReferralNodes.vue?vue&type=script&lang=ts&"
export * from "./ListReferralNodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports